import React from 'react';
import { TRACKER_STEPS } from '../../insurance/claims';
import { toneColors } from '../insurance/formBits';

// Created → Submitted → Accepted → Adjudicated → Paid. `tracker` = { index, tone } from the API.
export default function ClaimTracker({ tracker }) {
  const idx = tracker ? tracker.index : 0;
  const tone = tracker ? tracker.tone : 'neutral';
  const cur = toneColors(tone, 18);
  return (
    <ol aria-label="Claim progress" style={{ display: 'flex', gap: 6, listStyle: 'none', margin: 0, padding: 0, flexWrap: 'wrap' }}>
      {TRACKER_STEPS.map((label, i) => {
        const state = i < idx ? 'done' : i === idx ? 'current' : 'upcoming';
        const style = state === 'current'
          ? { background: cur.background, color: cur.color, border: `1px solid ${cur.color}` }
          : state === 'done'
            ? { background: 'var(--surface-muted)', color: 'var(--text-strong)', border: '1px solid var(--border-color)' }
            : { background: 'transparent', color: 'var(--text-muted)', border: '1px dashed var(--border-color)' };
        return (
          <li key={label} aria-current={state === 'current' ? 'step' : 'false'} data-state={state}
              style={{ ...style, borderRadius: 999, padding: '4px 12px', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>
            {i + 1}. {label}
          </li>
        );
      })}
    </ol>
  );
}
